// Cloudflare Turnstile CAPTCHA Integration

import { config, state } from './config.js';
import { showFormError, clearFormError } from './forms.js';

/**
 * Renders a Turnstile widget on the specified container
 */
export function renderTurnstileWidget(containerId, errorFieldId) {
    // Skip Turnstile on localhost to avoid sitekey errors
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        return null;
    }

    if (!config.turnstileSiteKey || typeof turnstile === 'undefined') {
        return null;
    }

    const container = document.getElementById(containerId);
    if (!container || container.hasChildNodes()) {
        return null;
    }

    return turnstile.render('#' + containerId, {
        sitekey: config.turnstileSiteKey,
        callback: function(token) {
            clearFormError(containerId, errorFieldId);
        },
        'error-callback': function() {
            showFormError(containerId, errorFieldId, 'Verification failed. Please try again.');
        },
        'expired-callback': function() {
            showFormError(containerId, errorFieldId, 'Verification expired. Please verify again.');
        }
    });
}

/**
 * Gets the Turnstile token
 */
export function getTurnstileToken(widgetId, containerId, errorFieldId) {
    if (!config.turnstileSiteKey || typeof turnstile === 'undefined' || widgetId === null) {
        return null;
    }

    const token = turnstile.getResponse(widgetId);
    if (!token) {
        showFormError(containerId, errorFieldId, 'Please complete the security verification');
        return null;
    }
    return token;
}

/**
 * Resets a Turnstile widget
 */
export function resetTurnstileWidget(widgetId) {
    if (widgetId !== null && typeof turnstile !== 'undefined') {
        turnstile.reset(widgetId);
    }
}

/**
 * Inject the Turnstile script tag on demand
 */
function loadTurnstileScript() {
    if (document.querySelector('script[src*="challenges.cloudflare.com/turnstile"]')) return;
    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
}

/**
 * Initialize Turnstile for download form
 */
export function initializeTurnstile() {
    if (!config.turnstileSiteKey) {
        console.log('Turnstile not configured - skipping widget initialization');
        const container = document.querySelector('.turnstile-container');
        if (container) {
            container.style.display = 'none';
        }
        return;
    }

    loadTurnstileScript();
    const widgetId = renderTurnstileWidget('downloadTurnstile', 'downloadTurnstileError');
    if (widgetId !== null) {
        state.downloadTurnstileWidgetId = widgetId;
    } else if (typeof turnstile === 'undefined') {
        setTimeout(initializeTurnstile, 100);
    }
}

/**
 * Reset download Turnstile widget
 */
export function resetTurnstile() {
    resetTurnstileWidget(state.downloadTurnstileWidgetId);
}

/**
 * Initialize checkout Turnstile
 */
export function initCheckoutTurnstile() {
    if (state.checkoutTurnstileWidgetId !== null) return;
    state.checkoutTurnstileWidgetId = renderTurnstileWidget('checkoutTurnstile', 'checkoutTurnstileError');
}

/**
 * Initialize enterprise Turnstile
 */
export function initEnterpriseTurnstile() {
    if (state.enterpriseTurnstileWidgetId !== null) return;
    state.enterpriseTurnstileWidgetId = renderTurnstileWidget('enterpriseTurnstile', 'enterpriseTurnstileError');
}
